/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum StrategyState {
    DRAFT = 'draft',
    VALIDATING = 'validating',
    VALIDATED = 'validated',
    REJECTED = 'rejected',
    PAPER = 'paper',
    LIVE = 'live',
    SUSPENDED = 'suspended',
    RETIRED = 'retired',
}
